import React, { useState, useEffect } from "react";
import { Image, Carousel } from "react-bootstrap";

function ImageGallery(props) {
  if (props.images) {
    return (
      <Carousel controls={false} indicators={false} interval={null} className={props.images.length === 1 ? "single-img" : ""}>
        {props.images.map((img, i) => {
          return (
            <Carousel.Item key={i}  >
              <Image className="product-img" role="presentation" src={img.fullURL} fluid />
            </Carousel.Item>
          );
        })}
      </Carousel>
    );
  }
  return <Image className="product-img" src="" fluid />;

}

export default ImageGallery;
